<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header"; 
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    treeselect
  },
  data() {
    return { 
      title: this.$t("userroles.Title"),
      items: [
        {
          text: this.$t("userroles.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      KullaniciRolleriGrup: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      YetkiAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles:[],
      KullanicilarArray:[],
      YetkiArray:[ ],
      Tab:1,
      ComboboxUser: [],
      user: []
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {
    loadOptions({ action,  callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          const options = this.user;

          callback(null, options)
        })
      }
    },
    user_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };

      if (veri.length>=3){
        this.user=[];
        let Filter="&name="+veri;
      this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-users",
          Page: Page,
          Filter: Filter,
      }).then((res) => {
        this.ComboboxUser = res.Data;
        for(var i=0; i<this.ComboboxUser.length;i++){
            this.user.push({ id: this.ComboboxUser[i].Email, label: this.ComboboxUser[i].FirstName + " " + this.ComboboxUser[i].LastName })
          }
      });

    }
  },
    Get() {

      this.KullaniciRolleri = [ ];
      this.KullanicilarArray = [ ]; 

      this.ActionsGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-roles",
        Page: this.PageToplu,
      }).then((res) => {
        res.Data = res.Data.sort(function (a, b) {return a.Title.localeCompare(b.Title);}); 
        this.KullaniciRolleriGrup = this.groupBy(res.Data, "Group");
        this.KullaniciRolleri = res.Data; 
        for(let i=0; i<res.Data.length; i++){  
          this.YetkiArray.push({
          id: res.Data[i].NormalizedName,
          label: res.Data[i].Name,
        });
        }
      });

    },
    KullaniciYetkiSorgu(kullanici) {
      this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
        Page: this.PageToplu,
        Filter: "&email=" + kullanici,
      }).then((res) => {
        this.SeciliKullaniciYetkileri = res.Data;
        this.Roles = res.Data.Roles
      });
    },
    YetkiKullaniciSorgu(yetki) { 
      this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-users-in-role",
        Page: this.PageToplu,
        Filter: "&role=" + yetki,
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    RolesPost(checked,value) {  
          let FormData = {
            Email: this.SeciliKullaniciYetkileri.Email,
            Role: value,
          }; 
      if(checked == true){ 
          this.Post(
            this.$config.API_ACCOUNT_URL + "Account/add-userroles",
            FormData
          );
      }else{
          this.Post(
            this.$config.API_ACCOUNT_URL + "Account/delete-userroles",
            FormData
          );
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="" :items="items" /> 
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active @click="Tab=1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block" >{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p> 
                  <b-form-group class="col-lg-12" id="example text" label-for="text">
                      <treeselect 
                      @search-change="user_yukle($event)"
                      :async="true"
                      :load-options="loadOptions"
                      :multiple="false" 
                      searchPromptText="Aramak için yazın..."
                      placeholder="Seçiniz..." 
                      name="KullaniciAra"
                      v-model="KullaniciAra" 
                      @select="KullaniciYetkiSorgu($event.id)"
                                
                      />
                      <treeselect-value :value="KullaniciAra" />
                    </b-form-group>
                </div>
              </b-tab>

              <b-tab  @click="Tab=2">
                <template v-slot:title  >
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"  >{{
                    $t("userroles.page.yetkilistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.yetkiler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkiyebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :options="YetkiArray"
                      placeholder="Seçiniz..."
                      v-model="YetkiAra" 
                      @select="YetkiKullaniciSorgu($event.id)"
                      /> 
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab ==1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            {{ this.$t("userroles.page.ekampusicin") }}
            <code>{{ KullaniciAra }}</code>
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div
              class="col-lg-4"
              v-for="(RollerGrup, index) in KullaniciRolleriGrup"
              :key="index"
            >
              <div class="mt-4 mt-lg-0">
                <h5 class="font-size-14 mb-3 w-100">
                  {{ RollerGrup[0].Group }}
                </h5>

                <div
                  class="form-check form-switch form-switch-md mb-3"
                  v-for="(Roller, index) in RollerGrup"
                  :key="index"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :id="Roller.Name"
                    v-model="Roles"
                    :value="Roller.Name"
                    @input="RolesPost($event.target.checked,$event.target.value)"
                  />
                  <label class="form-check-label" for="customSwitchsizemd">{{
                    Roller.Title
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="YetkiAra && Tab ==2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            <code>{{ YetkiAra }}</code>
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SeciliYetkiKullaniciliari"
                  :key="index"
                >
                  <td>{{ Kullanici.FirstName }}</td>
                  <td>{{ Kullanici.LastName }}</td>
                  <td>{{ Kullanici.Email }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
